module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/25/assets/images/f8a844f75cc8a85230bbec719cbca6aa.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_unassign.svg
// module id = ysx9
// module chunks = 0